import { PerformanceTracking } from '@freelancer/tracking';
import { ActionReducer } from '@ngrx/store';
import { storeFreeze } from 'ngrx-store-freeze';
import { TypedAction } from './actions';

export function storeFreezeReducerFactory(
  performanceTracking: PerformanceTracking,
) {
  return (reducer: ActionReducer<any, TypedAction>) => {
    const storeFreezeFn = storeFreeze(reducer);
    return (state: any, action: TypedAction) => {
      performanceTracking.mark('store-freeze-start');
      const next = storeFreezeFn(state, action);
      performanceTracking.mark('store-freeze-end');
      performanceTracking.measure(
        'store-freeze',
        'store-freeze-start',
        'store-freeze-end',
      );
      return next;
    };
  };
}



// WEBPACK FOOTER //
// ./src/@freelancer/datastore/core/store-freeze.reducer.ts